{
	"additionalFiltersMain": "Filter photos by rating, color labels, and flags.",
	"additionalFiltersTitle": "Additional Filters",
	"allPhotos": "All photos",
	"analyzingMetadata": "Analyzing metadata",
	"ariaBottomToolbar": "Bottom Toolbar",
	"ariaCullingFilters": "Culling Filters",
	"ariaDisplayedFiltersList": "Displayed Filters List",
	"ariaEditingFilters": "Editing Filters",
	"ariaFilmstripSortingOrderItem": "Filmstrip Sorting Order: {{option}}",
	"ariaFilmstripSortingOrderList": "Filmstrip Sorting Order List",
	"ariaOpenFilmstripSortOptions": "Open Filmstrip Sort Options",
	"ariaOpenFilmstripSortingOrder": "Open Filmstrip Sorting Order",
	"ariaOpenKeyboardShortcuts": "Open Keyboard Shortcuts",
	"ariaOpenPhotoCameraModelFiltersList": "Open Photo Camera Model Filters List",
	"ariaOpenPhotoFileTypeFiltersList": "Open Photo File Type Filters List",
	"ariaOpenPhotoPathFiltersList": "Open Photo Path Filters List",
	"ariaOpenSettings": "Open Settings",
	"ariaPhotoCameraModelFiltersList": "Photo Camera Model Filters List",
	"ariaPhotoColorFilters": "Photo Color Filters",
	"ariaPhotoDisplayedFiltersList": "Photo Displayed Filters List",
	"ariaPhotoFileTypeFiltersList": "Photo File Type Filters List",
	"ariaPhotoFlaggedRejectedFilters": "Photo Flagged/Rejected Filters",
	"ariaPhotoPathFiltersList": "Photo Path Filters List",
	"ariaPhotoRatingFilters": "Photo Rating Filters",
	"ariaPhotoVisibilityFilters": "Photo Visibility Filters",
	"ariaSettingsAndHelp": "Settings And Help",
	"allCameras": "All cameras",
	"displayGroupAll": "All",
	"displayGroupCandidates": "Candidates",
	"displayGroupCullingProcessing": "Processing",
	"displayGroupLocked": "Locked",
	"displayGroupProcessed": "Processed",
	"displayGroupProcessing": "Processing",
	"displayGroupReferences": "References",
	"displayGroupRejects": "Rejects",
	"displayGroupSuggested": "Suggested",
	"displayGroupTopPicks": "Top Picks",
	"displayGroupUnsupported": "Unsupported",
	"gotIt": "Got it",
	"filterCameraModel": "Camera model",
	"filterColor": "Color",
	"filterFileType": "File type",
	"filterFlag": "Flag",
	"filterFolder": "Folder",
	"filterRating": "Rating",
	"filterVisibility": "Visibility",
	"hiddenPhotosMain": "Your unselected photos are hidden in this filter.",
	"hiddenPhotosTitle": "Hidden Photos",
	"noStars": "No stars",
	"notShownBoth": "{{count}} images not shown ({{filtered}} filtered, {{hidden}} hidden)",
	"notShownFiltered": "{{count}} images not shown ({{filtered}} filtered)",
	"notShownHidden": "{{count}} images not shown ({{hidden}} hidden)",
	"photoCountFound": "{{displayCount}} of {{searchResultsCount}} found / {{allCount}} photos",
	"photoCountFoundAll": "{{searchResultsCount}} found / {{allCount}} photos",
	"photoCountPartial": "{{displayCount}} of {{allCount}} photos",
	"photoCountTotal": "{{allCount}} photos",
	"processing": "Processing",
	"ratingStars_one": "{{count}} Star",
	"ratingStars_other": "{{count}} Stars",
	"selected": " / {{count}} selected",
	"smartCullingFiltersMain": "Filter photos by Top Picks, Candidates, or Rejects.",
	"smartCullingFiltersTitle": "Smart Culling Filters",
	"sortCustom": "Custom",
	"sortDateAscending": "Capture Time (Oldest first)",
	"sortDateDescending": "Capture Time (Newest first)",
	"sortFilenameAscending": "Filename (A-Z)",
	"sortFilenameDescending": "Filename (Z-A)",
	"sortModifiedDateAscending": "Modified Time (Oldest first)",
	"sortModifiedDateDescending": "Modified Time (Newest first)",
	"suggestedPhotosMain": "You are only seeing suggested photos for you to mark reference edits. Suggested photos represent diverse lighting and are good starting points for AI to learn your aesthetics. You can unselect the Suggested filter to choose your own photos as references.",
	"suggestedPhotosTitle": "Suggested Photos",
	"tooltipUnsupported": "Unsupported",
	"unsupportedHidden": "Unsupported photos are hidden in this filter.",
	"visibilityHidden": "Hidden",
	"visibilityVisible": "Visible"
}
